export function orientationReducer(
  state = {
    loading: false,
    result: [],
    orientationResult: [],
    error: null
  },
  action
) {
  switch (action.type) {
    case "FETCH_ORIENTATIONS_BEGIN": {
      return { ...state, loading: true };
    }
    case "FETCH_ORIENTATIONS_REJECTED": {
      return { ...state, loading: false, error: action.payload };
    }
    case "FETCH_ORIENTATIONS_FULFILLED": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
